export default __webpack_public_path__ + "paddle_security_hoverfff34c.svg";